// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseTypeModel } from './caseTypeModel.js';
import type { SystemStatus } from './systemStatus.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CaseAllowedCaseStatusModel {
    'caseStatusId'?: number;
    'caseStatusCode'?: string;
    'caseStatusDescription'?: string;
    'systemStatus'?: SystemStatus;
    'isInitial'?: boolean;
    'isFinal'?: boolean;
    'caseSubStatusId'?: number;
    'caseSubStatusCode'?: string;
    'caseSubStatusDescription'?: string;
    'nextCaseTypes'?: Array<CaseTypeModel>;
    'isHidden'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseAllowedCaseStatusModel>> = [
        {
            "name":     "caseStatusId",
            "baseName": "caseStatusId",
            "type":     "number"
        },
        {
            "name":     "caseStatusCode",
            "baseName": "caseStatusCode",
            "type":     "string"
        },
        {
            "name":     "caseStatusDescription",
            "baseName": "caseStatusDescription",
            "type":     "string"
        },
        {
            "name":     "systemStatus",
            "baseName": "systemStatus",
            "type":     "SystemStatus"
        },
        {
            "name":     "isInitial",
            "baseName": "isInitial",
            "type":     "boolean"
        },
        {
            "name":     "isFinal",
            "baseName": "isFinal",
            "type":     "boolean"
        },
        {
            "name":     "caseSubStatusId",
            "baseName": "caseSubStatusId",
            "type":     "number"
        },
        {
            "name":     "caseSubStatusCode",
            "baseName": "caseSubStatusCode",
            "type":     "string"
        },
        {
            "name":     "caseSubStatusDescription",
            "baseName": "caseSubStatusDescription",
            "type":     "string"
        },
        {
            "name":     "nextCaseTypes",
            "baseName": "nextCaseTypes",
            "type":     "Array<CaseTypeModel>"
        },
        {
            "name":     "isHidden",
            "baseName": "isHidden",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return CaseAllowedCaseStatusModel.attributeTypeMap;
    }
}
